import script from "./QuestionGroupComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionGroupComponent.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionGroupComponent.vue?vue&type=style&index=0&id=3acabb90&lang=scss&scoped=true"
import "./QuestionGroupComponent.vue?vue&type=style&index=1&id=3acabb90&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3acabb90"]])

export default __exports__